import React from 'react'

const DailyLoan = () => {
    const loanChart = [
        { sno: 1, amount: 5000, months12: 78, months9: 55, months6: 48, months3: 40 },
        { sno: 2, amount: 10000, months12: 155, months9: 110, months6: 95, months3: 80 },
        { sno: 3, amount: 20000, months12: 310, months9: 220, months6: 190, months3: 160 },
        { sno: 4, amount: 25000, months12: 388, months9: 275, months6: 238, months3: 200 },
        { sno: 5, amount: 30000, months12: 465, months9: 330, months6: 285, months3: 240 },
        { sno: 6, amount: 40000, months12: 620, months9: 440, months6: 380, months3: 320 },
        { sno: 7, amount: 50000, months12: 775, months9: 550, months6: 480, months3: 400 },
        { sno: 8, amount: 60000, months12: 930, months9: 660, months6: 570, months3: 480 },
        { sno: 9, amount: 70000, months12: 1085, months9: 770, months6: 665, months3: 560 },
        { sno: 10, amount: 80000, months12: 1240, months9: 880, months6: 760, months3: 640 },
        { sno: 11, amount: 90000, months12: 1395, months9: 990, months6: 855, months3: 720 },
        { sno: 12, amount: 100000, months12: 1550, months9: 1100, months6: 950, months3: 800 },
        { sno: 13, amount: 200000, months12: 3100, months9: 2200, months6: 1900, months3: 1600 }
    ]
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    What is an Daily Loan?
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A daily loan is a type of short-term financing where the borrower is required to make repayments on a daily basis rather than monthly or weekly. These loans are typically designed for small businesses or individuals who need quick access to cash and can repay the loan with frequent, smaller installments. Daily loans are often used to manage working capital, cover operational costs, or handle emergencies.                </p>
            </div>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Ideal for:
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Small businesses with steady daily cash flow.
                    Entrepreneurs needing immediate cash for short-term business opportunities or emergencies.
                    Individuals seeking short-term loans with quick repayment cycles.
                </p>
            </div>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Feature of Fixed Deposit
                </h2>
                <div className='border'>
                    <div className='flex  bg-blue-600'>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium  text-md text-center text-white'>Sr No.</p>
                        </div>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium text-md text-center text-white'>Loan Amt (In Rs.)</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>70 DAYS</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>100 DAYS</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>121 DAYS</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center text-white'>150 DAYS</p>
                        </div>
                    </div>
                    {
                        loanChart.map((item) => (
                            <div className='flex '>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium  text-md text-center'>{item.sno}</p>
                                </div>
                                <div className='flex-1 p-4 '>
                                    <p className='font-medium text-md text-center'>{item.amount}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.months12}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.months9}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.months6}</p>
                                </div>
                                <div className='flex-1 p-4'>
                                    <p className='font-medium text-md text-center'>{item.months3}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default DailyLoan
